export type PipelineStatus = 'success' | 'error' | 'skipped'

export const success = (): Extract<PipelineStatus, 'success'> => 'success'
export const error = (): Extract<PipelineStatus, 'error'> => 'error'
export const skipped = (): Extract<PipelineStatus, 'skipped'> => 'skipped'

export const withAsyncPipeline = <T extends PipelineStatus>(
  handler: () => Promise<T>,
  afterScript: (status: T) => T | Promise<T>,
) => {
  return async () => {
    const status = await handler()

    await afterScript(status)
  }
}

export const withSyncPipeline = <T extends PipelineStatus>(handler: () => T, afterScript: (status: T) => T) => {
  return () => {
    const status = handler()

    afterScript(status)
  }
}

export const withSuccessCallback = <T extends PipelineStatus>(afterScript: (status: T) => T | Promise<T>) => {
  return (status: T): T | Promise<T> => {
    if (status === 'success') {
      return afterScript(status)
    }
    return status
  }
}

export const withFailureCallback = <T extends PipelineStatus>(
  afterScript: (status: Exclude<T, 'success'>) => T | Promise<T>,
) => {
  return (status: T): T | Promise<T> => {
    if (status !== 'success') {
      return afterScript(status as Exclude<T, 'success'>)
    }
    return status
  }
}
